import { useQuery } from 'react-query';
import PlaylistsApi from './api';

export function usePlaylistDetail(id: string | undefined, enabled = true) {
  return useQuery(
    ['playlist', id],
    () => PlaylistsApi.getOne(id!),
    { enabled: !!id && enabled },
  );
}
